import http from '@/utils/http';
import { dealwithParams } from './dealwith';
import { DBO_U } from '@op/utils/format';

export interface IFilter {
  [key: string]: Array<string>;
}

export interface IRequestData {
  filters?: IFilter;
  [key: string]: any;
}

export interface IRequestOptions {
  url: string;
  method: string;
  data?: IRequestData;
  [key: string]: any;
}

const request = (options: IRequestOptions) => {
  const map = DBO_U.query(window.location.href);

  const newOptions = dealwithParams(options);

  if (map.get('_refresh') === '1') {
    newOptions.headers = { 'Need-Cache': 0 };
  }

  return http(newOptions);
};

export default request;
